import React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

interface singleInputProps {
  onInputChangeOne: React.ChangeEventHandler<HTMLInputElement>;
  onInputChangeTwo: React.ChangeEventHandler<HTMLInputElement>;
  valueOne: string | number;
  placeholderOne: string;
  valueTwo: string | number;
  placeholderTwo: string;
}

const FormDoubleInput: React.FC<singleInputProps> = ({
  onInputChangeOne,
  onInputChangeTwo,
  valueOne,
  placeholderOne,
  valueTwo,
  placeholderTwo,
}) => {
  return (
    <React.Fragment>
      <Box
        sx={{
          display: { xs: "flex", md: "inline-flex" },
          marginTop: "15px",
          flexDirection: { xs: "column", md: "row" },
        }}
      >
        <Box
          sx={{
            marginRight: "15px",
            marginBottom: { xs: "5px" },
          }}
        >
          <Typography
            sx={{
              letterSpacing: "0px",
              color: "#7F7F7F",
              opacity: 0.6,
              fontFamily: "Avenir",
              fontSize: { xs: "11px", sm: "13px", md: "15px", xl: "20px" },
              lineHeight: {
                xs: "20px",
                sm: "22px",
                md: "24px",
                xl: "27px",
              },
              marginBottom: "4px",
            }}
          >
            First Name
          </Typography>
          <TextField
            required={true}
            placeholder={placeholderOne}
            onChange={onInputChangeOne}
            value={valueOne !== "" ? valueOne : ""}
            sx={{
              paddingBottom: 0,
              fontWeight: 500,
              background: "#F8F8F8",
              borderRadius: "4px",
              "& .MuiOutlinedInput-root": {
                width: { xs: "320px", md: "400px", xl: "553px" },
                height: { xs: "45px", md: "49px", xl: "60px" },
                fontFamily: "Avenir",
                letterSpacing: "0.5px",
                color: "#333333",
                opacity: 1,
                borderRadius: "4px",
                fontSize: {
                  xs: "12px",
                  sm: "14px",
                  md: "16px",
                  xl: "22px",
                },
                lineHeight: {
                  xs: "20px",
                  sm: "22px",
                  md: "30px",
                  xl: "30px",
                },
                "& fieldset": {
                  border: "1px solid #94949533",
                },
                "&:hover fieldset": {
                  border: "1px solid #94949533",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#94949533",
                },
              },
            }}
          />
        </Box>
        <Box>
          <Typography
            sx={{
              letterSpacing: "0px",
              color: "#7F7F7F",
              opacity: 0.6,
              fontFamily: "Avenir",
              fontSize: { xs: "11px", sm: "13px", md: "15px", xl: "20px" },
              lineHeight: {
                xs: "20px",
                sm: "22px",
                md: "24px",
                xl: "27px",
              },
              marginBottom: "4px",
            }}
          >
            Last Name
          </Typography>
          <TextField
            required={true}
            placeholder={placeholderTwo}
            onChange={onInputChangeTwo}
            value={valueTwo !== "" ? valueTwo : ""}
            sx={{
              paddingBottom: 0,
              fontWeight: 500,
              background: "#F8F8F8",
              borderRadius: "4px",
              "& .MuiOutlinedInput-root": {
                width: { xs: "320px", md: "400px", xl: "553px" },
                height: { xs: "45px", md: "49px", xl: "60px" },
                fontFamily: "Avenir",
                letterSpacing: "0.5px",
                color: "#333333",
                opacity: 1,
                borderRadius: "4px",
                fontSize: {
                  xs: "12px",
                  sm: "14px",
                  md: "16px",
                  xl: "22px",
                },
                lineHeight: {
                  xs: "20px",
                  sm: "22px",
                  md: "30px",
                  xl: "30px",
                },
                "& fieldset": {
                  border: "1px solid #94949533",
                },
                "&:hover fieldset": {
                  border: "1px solid #94949533",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#94949533",
                },
              },
            }}
          />
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default FormDoubleInput;
